(function (angular) {
    var Slide = /** @class */ (function () {
        function Slide($element, cacheMemoryService, $timeout, $scope, startDate, endDate) {
            this.$element = $element;
            this.cacheMemoryService = cacheMemoryService;
            this.$timeout = $timeout;
            this.$scope = $scope;
            this.startDate = startDate;
            this.endDate = endDate;
            this.cacheGetAvailableVehicles = this.cacheMemoryService.get('GetAvailableVehicles');
            this.cacheGetAllBookings = this.cacheMemoryService.get('getAllBookings');
        }
        Slide.prototype.isCached = function () {
            return this.cacheGetAllBookings.has(this.startDate + this.endDate) || this.cacheGetAvailableVehicles.has(this.startDate + this.endDate);
        };
        Slide.prototype.canPreload = function () {
            return this.preload && !this.isCached();
        };
        Slide.prototype.cancelPreload = function () {
            this.$timeout.cancel(this.timer);
        };
        Slide.prototype.preload = function (delay) {
            var _this = this;
            //cancel timeout
            this.$timeout.cancel(this.timer);
            if (!delay) {
                this.$scope.$broadcast('refreshData');
            }
            else {
                this.timer = this.$timeout(delay).then(function () {
                    _this.$scope.$broadcast('refreshData');
                });
            }
        };
        return Slide;
    }());
    var SwiperController = /** @class */ (function () {
        function SwiperController($scope, $element, $compile, $q, $timeout, $http, cacheMemoryService, localStorageService, $mdDialog) {
            this.$scope = $scope;
            this.$element = $element;
            this.$compile = $compile;
            this.$q = $q;
            this.$timeout = $timeout;
            this.$http = $http;
            this.cacheMemoryService = cacheMemoryService;
            this.localStorageService = localStorageService;
            this.$mdDialog = $mdDialog;
            this.slides = [];
            this.preload = true;
            this.timers = [];
            //Create cache
            this.cacheGetAvailableVehicles = this.cacheMemoryService.get('GetAvailableVehicles');
            this.cacheGetAllBookings = this.cacheMemoryService.get('getAllBookings');
            //Assgin StartDate,EndDate
            this.startDate = this.$scope.startDate;
            this.endDate = this.$scope.endDate;
            this.bindEvents();
            this.onInit();
        }
        SwiperController.prototype.onInit = function () {
            var _this = this;
            //Create swiper
            this.swiper = new Swiper2(this.$element.find('.swiper-container'), {
                loop: false,
                init: false,
                initialSlide: 1,
                swipeHandler: ".slider-handle",
                runCallbacksOnInit: false,
                on: {
                    slideChangeTransitionStart: function () {
                        //Lock page when begin slide
                        _this.lock();
                    },
                    slidePrevTransitionEnd: function () {
                        //Update date startDate
                        _this.startDate = moment(_this.startDate, "YYYY-MM-DD").subtract(7, "days").format('YYYY-MM-DD');
                        //Create new slide and prepend slide to fist item
                        var nextStartDate = moment(_this.startDate, "YYYY-MM-DD").subtract(7, "days"), nextEndDate = moment(nextStartDate).add(6, "days");
                        _this.prependSlide(nextStartDate.format('YYYY-MM-DD'), nextEndDate.format('YYYY-MM-DD'));
                        //Remove last item
                        _this.removeLastSlide();
                        //Update swiper control
                        _this.swiper.realIndex = 1;
                        _this.swiper.activeIndex = 1;
                        _this.swiper.previousIndex = 0;
                        _this.update();
                        //Unlock page
                        _this.unlock();
                        //Load slide 1
                        _this.slides[1].preload();
                        //Preload slide[0] after 1000ms if  slide[0] can preload
                        if (_this.slides[0].canPreload()) {
                            _this.slides[0].preload(1000);
                        }
                    },
                    slideNextTransitionEnd: function () {
                        //Update date startDate
                        _this.startDate = moment(_this.startDate, "YYYY-MM-DD").add(7, "days").format('YYYY-MM-DD');
                        //Add next date
                        var nextStartDate = moment(_this.startDate, "YYYY-MM-DD").add(7, "days"), nextEndDate = moment(nextStartDate).add(6, "days");
                        _this.appendSlide(nextStartDate.format('YYYY-MM-DD'), nextEndDate.format('YYYY-MM-DD'));
                        //Remove first slide
                        _this.removeFirstSlide();
                        //Update swiper control
                        _this.swiper.realIndex = 1;
                        _this.swiper.activeIndex = 1;
                        _this.swiper.previousIndex = 0;
                        _this.update();
                        //Unlock page
                        _this.unlock();
                        //Load slide 1
                        _this.slides[1].preload();
                        //Preload slide[2] after 1000ms if  slide[2] can preload
                        if (_this.slides[2].canPreload()) {
                            _this.slides[2].preload(1000);
                        }
                    }
                }
            });
            //slide 1
            if (!this.localStorageService.get("addvehiclebookings-showed-guide")) { //Show guide
                this.lock();
                this.appendSlide(this.startDate, this.endDate, true, function (vehicles) {
                    if (vehicles.length > 0) {
                        var timer = _this.$timeout(100);
                        _this.timers.push(timer);
                        timer.then(function () {
                            _this.showGuideAnimation().finally(function () {
                                _this.localStorageService.set("addvehiclebookings-showed-guide", true);
                                _this.unlock();
                            });
                        });
                    }
                    else {
                        _this.unlock();
                    }
                });
            }
            else {
                //Create slide 1
                this.appendSlide(this.startDate, this.endDate, true);
            }
            //slide 0
            var startDate1 = moment(this.startDate, "YYYY-MM-DD").subtract(7, "days"), endDate1 = moment(startDate1).add(6, "days");
            this.prependSlide(startDate1.format('YYYY-MM-DD'), endDate1.format('YYYY-MM-DD'));
            //slide 2
            var startDate2 = moment(this.startDate, "YYYY-MM-DD").add(7, "days"), endDate2 = moment(startDate2).add(6, "days");
            this.appendSlide(startDate2.format('YYYY-MM-DD'), endDate2.format('YYYY-MM-DD'));
            //init swiper
            this.swiper.init();
            //Preload slide[0], slide[2]
            if (this.preload) {
                this.slides[0].preload(1000);
                this.slides[2].preload(1000);
            }
        };
        SwiperController.prototype.bindEvents = function () {
            var _this = this;
            this.$scope.$on("$destroy", function () {
                _this.$mdDialog.cancel();
                for (var _i = 0, _a = _this.timers; _i < _a.length; _i++) {
                    var timer = _a[_i];
                    _this.$timeout.cancel(timer);
                }
            });
        };
        /**
         * Create slide from startdate,endDate
         * @param {string} startDate
         * @param {string} endDate
         * @param {boolean} initData
         * @param {Function} onLoad
         * @returns {Slide}
         */
        SwiperController.prototype.createSlide = function (startDate, endDate, initData, onLoad) {
            var scope = this.$scope.$new(true);
            scope.startDate = startDate;
            scope.endDate = endDate;
            scope.initData = initData;
            scope.showGuide = true;
            scope.onLoad = onLoad;
            var html = '<vehicles-booking init-data="initData" on-load="onLoad(vehicles)"   class="swiper-slide"   start-date="startDate" end-date="endDate" ></vehicles-booking>';
            var element = this.$compile(html)(scope);
            return new Slide(element, this.cacheMemoryService, this.$timeout, scope, startDate, endDate);
        };
        /**
         * Create and append side to last item
         * @param {string} startDate
         * @param {string} endDate
         * @param {boolean} initData
         * @param {Function} onLoad
         */
        SwiperController.prototype.appendSlide = function (startDate, endDate, initData, onLoad) {
            var slide = this.createSlide(startDate, endDate, initData, onLoad);
            this.slides.push(slide);
            slide.$element.appendTo(this.$element.find('.swiper-wrapper'));
        };
        /**
         * Create slide and prepend slide to first item
         * @param {string} startDate
         * @param {string} endDate
         * @param {boolean} initData
         * @param {Function} onLoad
         */
        SwiperController.prototype.prependSlide = function (startDate, endDate, initData, onLoad) {
            var slide = this.createSlide(startDate, endDate, initData, onLoad);
            this.slides.splice(0, 0, slide);
            slide.$element.prependTo(this.$element.find('.swiper-wrapper'));
        };
        /**
         * Remove slide by index
         * @param {number} index
         */
        SwiperController.prototype.removeSlide = function (index) {
            var _this = this;
            $(this.$element.find('vehicles-booking')[index]).remove();
            var slide = this.slides.splice(index, 1)[0];
            slide.cancelPreload();
            _.each(this.$http.pendingRequests, function (request) {
                if (request.url.lastIndexOf("GetAvailableVehicles") !== -1 || request.url.lastIndexOf("getAllBookings") !== -1) {
                    if (request.data.From === slide.startDate && request.data.To === slide.endDate) {
                        _this.$http['abort'](request);
                    }
                }
            });
        };
        /**
         * Remove first slide
         */
        SwiperController.prototype.removeFirstSlide = function () {
            this.removeSlide(0);
        };
        /**
         * remove last slide
         */
        SwiperController.prototype.removeLastSlide = function () {
            this.removeSlide(this.slides.length - 1);
        };
        /**
         * Update html of swiper
         */
        SwiperController.prototype.update = function () {
            this.swiper.update();
        };
        /**
         * Lock page
         */
        SwiperController.prototype.lock = function () {
            this.$element.find(".lock").show();
        };
        /**
         * Unlock page
         */
        SwiperController.prototype.unlock = function () {
            this.$element.find(".lock").hide();
        };
        /**
         * Render
         * @param fn
         */
        SwiperController.prototype.safeApply = function (fn) {
            var phase = this.$scope.$root.$$phase;
            if (phase === '$apply' || phase === '$digest') {
                if (fn && (typeof (fn) === 'function')) {
                    fn();
                }
            }
            else {
                this.$scope.$apply(fn);
            }
        };
        /**
         * Show guide modal
         * @param {number} width
         * @param {number} top
         * @returns {angular.IPromise<any>}
         */
        SwiperController.prototype.showGuideModal = function (width, top) {
            var _this = this;
            return this.$q(function (resolve) {
                var scope = _this.$scope.$new(true);
                scope.right = width;
                scope.top = top;
                _this.$mdDialog.show({
                    templateUrl: 'js/internal/vehiclebookings/addvehiclebooking/guide.html',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    scope: scope
                }).finally(function () {
                    var vehicle = $(_this.$element.find("vehicles-booking")[1]).find("vehicle:first").removeClass('show-guide-animation');
                    vehicle.find(".helper").remove();
                    resolve();
                });
            });
        };
        /**
         * Show guide
         * @returns {angular.IPromise<any>}
         */
        SwiperController.prototype.showGuideAnimation = function () {
            var _this = this;
            return this.$q(function (resolve) {
                var vehicle = $(_this.$element.find("vehicles-booking")[1]).find("vehicle:first").addClass('show-guide-animation'), daysContainer = vehicle.find('.vehicle-days'), helper = $("<div class='helper'></div>").appendTo(daysContainer);
                var index = 4;
                var timer1 = _this.$timeout(100);
                _this.timers.push(timer1);
                timer1.then(function () {
                    helper.css({
                        left: (index * 100) / 7 + '%',
                        width: 100 - (index * 100 / 7) + '%'
                    });
                });
                var timer2 = _this.$timeout(1000);
                _this.timers.push(timer2);
                timer2.then(function () {
                    var right = ((7 - index) * daysContainer.width()) / 7 + 15, top = vehicle.offset().top + (vehicle.height() / 2) - 15;
                    _this.showGuideModal(right, top).finally(resolve);
                });
            });
        };
        SwiperController.$inject = ['$scope', '$element', '$compile', '$q', '$timeout', '$http', 'CacheMemoryService', 'localStorageService', '$mdDialog'];
        return SwiperController;
    }());
    angular.module('shared').directive('swiper', function () {
        return {
            restrict: 'E',
            controller: SwiperController,
            templateUrl: 'js/internal/vehiclebookings/directives/swiper/swiper.html',
            scope: {
                startDate: '=',
                endDate: '='
            }
        };
    });
}(angular));
